// extracted by mini-css-extract-plugin
module.exports = {"depositListOrderList":"DepositListOrderList-Jtails_depositListOrderList_2ifIf","prepaidList":"DepositListOrderList-Jtails_prepaidList_2gGkU"};